// extracted by mini-css-extract-plugin
export default {"iconButton":"purchase_iconButton__C-DTR","buttonText":"purchase_buttonText__UYxUl"};